/**
 * Harry header glyph — stroke style matching Lucide top-bar icons (h-4 w-4).
 * Simplified from the illustrated avatar: bald head, glasses, beard, headphones.
 */

export function HarryHeaderIcon({ className = 'h-4 w-4 shrink-0' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden
    >
      {/* Headphones band */}
      <path d="M5 11.5c0-4.2 3.1-7.5 7-7.5s7 3.3 7 7.5" />
      <rect x="3.25" y="11" width="3.5" height="6" rx="1.2" />
      <rect x="17.25" y="11" width="3.5" height="6" rx="1.2" />
      {/* Head */}
      <circle cx="12" cy="13.5" r="4.25" />
      {/* Glasses */}
      <circle cx="9.9" cy="13.6" r="1.35" />
      <circle cx="14.1" cy="13.6" r="1.35" />
      <path d="M11.25 13.6h1.5" />
      <path d="M8.55 13.6H7.4M16.6 13.6h1.15" />
      {/* Beard */}
      <path d="M9.8 16.1c.7.9 1.5 1.35 2.2 1.35s1.5-.45 2.2-1.35" />
    </svg>
  );
}
